import { createReducer, on } from '@ngrx/store';
import processActions from './insured-import.actions';
import { ApiState } from '../../model/api-state.model';
import AppError from 'src/app/model/app-error';
import { InsuredImportResponse } from 'src/app/model/insured-import.model';

export { processActions as actions };

export * from './insured-import.selectors';

export interface State {
  state: ApiState;
  data: InsuredImportResponse | null;
  error: AppError | null;
  importedToForm: boolean;
}

export const initialState: State = {
  state: ApiState.idle,
  data: null,
  error: null,
  importedToForm: false,
};

export const reducer = createReducer(
  initialState,
  on(processActions.start, (state) => ({ ...state, state: ApiState.pending })),
  on(processActions.success, (state, { success }) => ({
    ...state,
    state: ApiState.success,
    data: success,
    error: null,
  })),
  on(processActions.error, (state, { error }) => ({
    ...state,
    state: ApiState.error,
    data: null,
    error,
  })),
  on(processActions.reset, (state) => ({
    ...state,
    state: ApiState.idle,
    data: null,
    error: null,
  })),
  on(processActions.succesfullyImported, (state, { importedToForm }) => ({
    ...state,
    importedToForm,
  })),
);
